<template>
    <div>
        <h3 class="mb-3 mt-2">Vehicle Type DropDown</h3>
        <vs-row>
            <vs-col vs-xs="12" vs-sm="10" vs-lg="10" class="px-0 pr-2 mb-base">
                <vs-input
                    class="w-full"
                    placeholder="Type to Search"
                    v-model="filters.search"
                />
            </vs-col>
            <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="mb-base p-0">
                <vx-tooltip text="Refresh Data" color="primary" >
                    <vs-button color="primary" type="filled" class="w-full" @click="init()" :disabled="loading">
                        <font-awesome-icon :icon="redoIcon" />
                    </vs-button>
                </vx-tooltip>
                <vx-tooltip text="Create Vehicle Type" color="primary" class="ml-2">
                    <router-link :to="{name: 'vehicle-type-new'}">
                        <vs-button color="primary" type="filled" class="w-full" :disabled="loading">
                            <font-awesome-icon :icon="addIcon" />
                        </vs-button>
                    </router-link>
                </vx-tooltip>
            </vs-col>
        </vs-row>
		<div class="vx-col w-full mb-base">
            <vx-card>
                <vs-table class="freeze_row row2" :data="results" slot="no-body" :hoverFlat="true" stripe>
                    <vs-tr>
                        <vs-th>ID</vs-th>
                        <vs-th>Issue Type Category</vs-th>
                        <vs-th>Name</vs-th>
                        <vs-th>Active</vs-th>
                        <vs-th>Created On</vs-th>
                        <vs-th>Action</vs-th>
                    </vs-tr>
                    <template>
                        <template v-for="(item, index) in results">
                            <vs-tr :key="index">
                                <vs-td>
                                    {{ item.id }}
                                </vs-td>
                                <vs-td>
                                    <FormatText :text="item.issue_type_category" format="select" :kwargs="issue_type_category_options" />
                                </vs-td>
                                <vs-td>
                                    {{ item.name }}
                                </vs-td>
                                <vs-td>
                                    {{ item.active ? 'Yes' : 'No'}}
                                </vs-td>
                                <vs-td>
                                    <FormatText :text="item.created_on" format="datetime" />
                                </vs-td>
                                <vs-td>
                                    <router-link :to="{name: 'vehicle-type-edit', params: {vehicle_type_id: item.id}}">
                                        <vs-button type="filled" size="small" color="primary">View</vs-button>
                                    </router-link>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </template>
                </vs-table>
            </vx-card>
        </div>
        <template v-if="!disable_pagination">
            <vs-row v-if="total_results" class="mt-3 text-center">
                <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
            </vs-row>
        </template>
    </div>
</template>

<script>
import { faPlus, faRedo } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../../utils/requests'

export default {
	props: {
        embedded_mode: {
            required: false,
            default: false
        },
        embedded_filters: {
            required: false,
            default: () => {}
        },
        disable_pagination: {
            required: false,
            default: false
        }
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0);
        let limit = parseInt(this.$route.query.limit || 20);

        let current_page = Math.ceil((offset + limit) / limit);
        return  {
            results: [],

			next_url: null,
            loading: false,
            total_results: null,
            current_page: current_page,
            filters: {
                search: this.$route.query.search || null,
                ordering: this.$route.query.ordering || '-created_on',
                offset: offset,
                limit: limit
            },

            issue_type_category_options: [
                {value: 'incident', label: "Incident"},
                {value: 'vehicle_breakdown', label: "Vehicle Breakdown"},
                {value: 'unauthorised_parking', label: "Unauthorised Parking"},
                {value: 'traffic_violation', label: "Traffic Violation"},
                {value: 'road_user_accident', label: "Road User Accident"},
            ],

            submit_disabled: false,
            api_errors: {}
        }
    },
    mounted() {
        this.init()
    },
	computed: {
        total_pages() {
            if(this.total_results == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_results/this.filters.limit)
        },
        redoIcon: () => faRedo,
        addIcon: () => faPlus
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if (this.current_page == null) return;

                if (this.timer) clearTimeout(this.timer);

                this.timer = setTimeout(() => {
                    this.$router.push({ name: this.$route.name, query: {...newV, ...this.embedded_query_params} });
                }, 800);
            }
        },
        "$route.query"(newV) {
            this.load_data(newV);
        },
        current_page(newV, oldV) {
            if (newV == oldV) return;
            this.filters.offset = (newV - 1) * this.filters.limit;
        }
    },
    methods: {
        init(){
            this.load_data(this.filters)
        },
        calculate_page() {
            if (this.filters.offset == 0) this.current_page = 1;
            else
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit);
        },
        load_data(filters=null) {
            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.data_vehicle_types

            let payload = filters

            if (!payload) payload = {};

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters };
            }

            this.api_errors = {}

            Request(this, 'GET', url, payload).then( 
                (res) => {
                    this.results = res.results
                    this.total_results = res.count
                    this.next_url = res.next;
                    this.loading = false;
                    this.$vs.loading.close();
                }, 
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Unable to load Organisations. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        }
    }
}
</script>